import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useIntl, useFeatureToggles, useSelector } from "@grandvisionhq/state";
import { useSetShippingMethodState } from "../../../../hooks/operations/hooks/operations/use-set-shipping-method-state.js";
import { getSelectedPostalCode } from "../../../StepShipping/selectors.js";
const useUpdatedShippingMethods = ({ onNextStep, isServiceStoreUpdating }) => {
  const { cart } = Context.useCart();
  const { country } = useIntl();
  const { allowAlternativeShippingState, featureConfigs } = useFeatureToggles();
  const { alternativeShippingRegex } = featureConfigs;
  const postalCode = useSelector(getSelectedPostalCode);
  const [shouldShowUpdatedShippingMethodsModal, setShouldShowUpdatedShippingMethodsModal] = React.useState(false);
  const { setShippingMethodState } = useSetShippingMethodState();
  const resetShippingMethodsStateRef = React.useRef(false);
  const resetShippingMethodsState = React.useCallback(() => {
    setShippingMethodState(country);
    resetShippingMethodsStateRef.current = true;
  }, [country, setShippingMethodState]);
  React.useEffect(() => {
    if (allowAlternativeShippingState && cart?.id && !isServiceStoreUpdating && !resetShippingMethodsStateRef.current) {
      resetShippingMethodsState();
    }
  }, [cart?.id]);
  const isShippingMethodStateValid = React.useCallback(() => {
    if (!allowAlternativeShippingState) {
      return true;
    }
    return Boolean(
      postalCode && alternativeShippingRegex && !alternativeShippingRegex?.test(postalCode)
    );
  }, [allowAlternativeShippingState, alternativeShippingRegex, postalCode]);
  const handleSetShippingMethodStateCompleted = React.useCallback(
    (cartId) => {
      if (!cartId) {
        console.error("No cart ID provided after setting shipping method state");
        onNextStep();
      } else {
        setShouldShowUpdatedShippingMethodsModal(true);
      }
    },
    [onNextStep]
  );
  const { setShippingMethodState: setShippingMethodStateWithCallback } = useSetShippingMethodState({
    onCompleted: handleSetShippingMethodStateCompleted
  });
  const handleUpdateShippingMethodsState = React.useCallback(() => {
    postalCode && setShippingMethodStateWithCallback(country, postalCode);
  }, [country, postalCode, setShippingMethodStateWithCallback]);
  return React.useMemo(
    () => ({
      handleUpdateShippingMethodsState,
      isShippingMethodStateValid,
      shouldShowUpdatedShippingMethodsModal,
      onCloseUpdatedShippingMethodsModal: () => setShouldShowUpdatedShippingMethodsModal(false)
    }),
    [
      handleUpdateShippingMethodsState,
      isShippingMethodStateValid,
      shouldShowUpdatedShippingMethodsModal
    ]
  );
};
export {
  useUpdatedShippingMethods
};
//# sourceMappingURL=use-updated-shipping-methods.js.map
